<ng-container *transloco="let convert;">
  <div>
    <div class="form-group mb-0">
      <label data-test-id="available-ambassadors-filter-state-label" class="control-label">{{ stateOrProvinceLabel }}</label>
    </div>
    <div class="d-flex">
      <div class="flex-grow-1">
        <div class="form-group">
          <div class="select-wrapper">
            @if (!isCanadianTenantEnabled) {
              <select
                data-test-id="available-ambassadors-filter-state-select"
                #stateSelect
                id="startModelYear"
                class="custom-select state-select"
                (change)="stateChanged()"
                >
                @for (state of stateOrProvince; track state) {
                  <option value="{{ state.name }}">{{ state.name }}</option>
                }
              </select>
            }
            @if (isCanadianTenantEnabled) {
              <select
                data-test-id="available-ambassadors-filter-province-select"
                #provinceSelect
                id="startModelYear"
                class="custom-select state-select"
                (change)="provinceChanged()"
                >
                @for (province of stateOrProvince; track province) {
                  <option value="{{ province.name }}">{{ province.name }}</option>
                }
              </select>
            }
          </div>
        </div>
      </div>
    </div>

    <app-legacy-table
      [columns]="columns"
      [cardConfig]="cardConfig"
      >
      @for (row of ambassadors; track row; let i = $index) {
        <table-row-group>
          <table-row [columns]="columns" [row]="row">
            <table-cell *appTableCell="let row; column: 'name'" [attr.data-test-id]="'available-ambassadors-table-name-cell-' + i" (click)="toggleDrawer(i)">
              <div
                allytm-click-tagged="false"
                aria-hidden="true"
                class="btn btn-link name-column"
              >{{ row?.name }}</div>
            </table-cell>
            <table-cell *appTableCell="let row; column: 'phone'">
              <div class="cell">
                {{ row?.phone ? reformatPhone(row.phone) : '' }}
              </div>
            </table-cell>
            <table-cell *appTableCell="let row; column: 'email'">
              <div class="cell">{{ row?.email }}</div>
            </table-cell>
            <table-cell *appTableCell="let row; column: 'actions'">
              <button
                [attr.data-test-id]="'available-ambassadors-table-authorize-button-' + i"
                allytmln="authorize"
                class="btn btn-outline-primary"
                (click)="openModal(row)"
                >
                {{ convert('authorizedAmbassadorsModal.authorizeBtn') }}
              </button>
            </table-cell>
          </table-row>
          <table-row [row]="row" [expandable]="true" #drawer>
            <table-cell *appTableCell="let row; colSpan: columns.length">
              <div class="container drawer">
                <h4 [attr.data-test-id]="'available-ambassadors-drawer-name-' + i">{{ row?.name }}</h4>
                {{ row?.comment || 'N/A' }}
                <button
                  [attr.data-test-id]="'available-ambassadors-drawer-close-button-' + i"
                  allytmln="drawerClose"
                  class="drawer__close"
                  [attr.aria-label]="convert('common.btnClose')"
                  (click)="closeDrawer(i)"
                  >
                  <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                </button>
              </div>
            </table-cell>
          </table-row>
        </table-row-group>
      }

      @if (!ambassadors || ambassadors.length === 0) {
        <table-row-group>
          <table-row>
            <table-cell *appTableCell="let row; colSpan: columns.length">
              {{availableAmbassadorsTranslation.textNoAmbassadors}}
            </table-cell>
          </table-row>
        </table-row-group>
      }
    </app-legacy-table>
  </div>
  <app-authorize-ambassadors-modal
    #AuthorizeAmbassadorsModalComponent
    [modalId]="'authorize-ambassadors-modal'"
    (ambassadors)="setNewAvailableAmbassadors($event)"
    (success)="showSuccess($event)"
    (error)="ambassadorResponseModalComponent.show()"
  ></app-authorize-ambassadors-modal>
  <app-ambassador-response-modal
    [modalId]="'ambassador-response-modal'"
  ></app-ambassador-response-modal>
</ng-container>
